import { render } from "./VODCaptionsTab.vue?vue&type=template&id=b84c625e&scoped=true"
import script from "./VODCaptionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODCaptionsTab.vue?vue&type=script&setup=true&lang=js"

import "./VODCaptionsTab.vue?vue&type=style&index=0&id=b84c625e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84c625e"],['__file',"src/components/VOD/VODCaptionsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b84c625e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b84c625e', __exports__)) {
    api.reload('b84c625e', __exports__)
  }
  
  module.hot.accept("./VODCaptionsTab.vue?vue&type=template&id=b84c625e&scoped=true", () => {
    api.rerender('b84c625e', render)
  })

}


export default __exports__